import { matchRoutes, RouteConfig } from 'react-router-config'
import { Store } from 'redux'

import { IPageComponent } from '../../typings/pageComponent'
import { IRootState } from '../reducers'
import { ICommonLocation } from './location/types'

export const fetchAllRequests = (
  store: Store<IRootState>,
  location: ICommonLocation,
  routes: RouteConfig[],
  apiUrlPrefix: string
) =>
  matchRoutes(routes, location.pathname).map(({ route, match }) => {
    const component = route.component as IPageComponent<any>
    return component && component.loadData
      ? component.loadData(store, location, apiUrlPrefix, match)
      : Promise.resolve({
          // resolve empty action
          type: 'noopAction'
        })
  })

export const callBeforePageViewHandlers = (
  store: Store<IRootState>,
  location: ICommonLocation,
  routes: RouteConfig[]
) => {
  matchRoutes(routes, location.pathname).forEach(({ route, match }) => {
    const component = route.component as IPageComponent<any>
    if (component && component.onBeforePageView) {
      component.onBeforePageView(store, location, match)
    }
  })
}
